import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAzFs9Ps5EuLJSfCMe66EBM5RK8inCCTEQ",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "monyxx.com.br",
  projectId: "monyxx",
  storageBucket: "monyxx.firebasestorage.app",
  messagingSenderId: "435894396794",
  appId: "1:435894396794:web:5ce68cc3a82f84a1a998c3",
  measurementId: "G-QWYHGSS0H1"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
